var _rect, _path, _path2, _line, _line2, _line3, _line4, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorAssignedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 17,
    height: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.33203C4.5 1.22746 5.39543 0.332031 6.5 0.332031H21.5C22.6046 0.332031 23.5 1.22746 23.5 2.33203V9.83203H4.5V2.33203Z",
    fill: "#006F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.33203H21.5C22.0523 1.33203 22.5 1.77975 22.5 2.33203V24.6654H5.5V2.33203C5.5 1.77975 5.94772 1.33203 6.5 1.33203Z",
    stroke: "#006F9F",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.33398,
    y1: 24.668,
    x2: 25.6673,
    y2: 24.668,
    stroke: "#006F9F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 12.75,
    x2: 8.75,
    y2: 12.75,
    stroke: "#006F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 20.75,
    x2: 8.75,
    y2: 20.75,
    stroke: "#006F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 16.75,
    x2: 8.75,
    y2: 16.75,
    stroke: "#006F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22,
    r: 9,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 22.2C30.4 24.1096 29.6414 25.9409 28.2912 27.2912C26.9409 28.6414 25.1096 29.4 23.2 29.4C21.2904 29.4 19.4591 28.6414 18.1088 27.2912C16.7586 25.9409 16 24.1096 16 22.2C16 20.2904 16.7586 18.4591 18.1088 17.1088C19.4591 15.7586 21.2904 15 23.2 15C25.1096 15 26.9409 15.7586 28.2912 17.1088C29.6414 18.4591 30.4 20.2904 30.4 22.2ZM26.9664 19.2336C26.8921 19.1591 26.8038 19.1 26.7066 19.0597C26.6094 19.0193 26.5052 18.9986 26.4 18.9986C26.2948 18.9986 26.1906 19.0193 26.0934 19.0597C25.9962 19.1 25.9079 19.1591 25.8336 19.2336L21.6 23.4688L20.5664 22.4336C20.4162 22.2834 20.2124 22.199 20 22.199C19.7876 22.199 19.5838 22.2834 19.4336 22.4336C19.2834 22.5838 19.199 22.7876 19.199 23C19.199 23.2124 19.2834 23.4162 19.4336 23.5664L21.0336 25.1664C21.1079 25.2409 21.1962 25.3 21.2934 25.3403C21.3906 25.3807 21.4948 25.4014 21.6 25.4014C21.7052 25.4014 21.8094 25.3807 21.9066 25.3403C22.0038 25.3 22.0921 25.2409 22.1664 25.1664L26.9664 20.3664C27.0409 20.2921 27.1 20.2038 27.1403 20.1066C27.1807 20.0094 27.2014 19.9052 27.2014 19.8C27.2014 19.6948 27.1807 19.5906 27.1403 19.4934C27.1 19.3962 27.0409 19.3079 26.9664 19.2336Z",
    fill: "#006F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorAssignedIcon);
export default __webpack_public_path__ + "static/media/door-assigned-icon.47541485735085acac0aa212a31f7786.svg";
export { ForwardRef as ReactComponent };